/**
 * Copyright © Veeam Software Group GmbH.
 */

export const DEFAULT_TENANT_QUOTA = 20;
